import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

const FilterListWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    min-height: 190px;
    height: 190px;
    padding: 0 4px;
    border-right: none;
    font-size: 14px;
    width: 250px;
    background-color: white;
    border: 1px solid ${colours.grey[400]};

    .learningGapsButton {
      height: 32px;
      background-color: #00a5ff;
      color: white;
      margin: 0 10px;
      outline: none;
      border-color: #00a5ff;
      line-height: 12px;
    }
`;
});

const FilterWrapper = styled.div`
  padding: 10px;
`;

const InputWrapper = styled.input((props) => {
  const { typography, palette } = ThemeHelper.getTheme(props);

  return ` 
        height: 30px;
        font-family: ${typography.family};
        font-size: 14px;
        padding-left: 4px;
        width: 97%;
        border-radius: 5px;
        outline: none;
        border: 1px solid #cfd2d4;
        color: ${palette.primary.dark};
    `;
});

export {
  FilterListWrapper,
  FilterWrapper,
  InputWrapper
};
